import { useRecoilState } from "recoil"
import { sizeState } from "../recoil-atom"

const Init = () => {
  const [size, setSize] = useRecoilState(sizeState)
  
  return (
    <>
      <div className="init">
        <div className="init-logo">
          {/* <img src="/logoA.png" width="64px" /> */}
        </div>
        <div>openmark</div>
      </div>

      <style jsx>{`
        .init {
          width: 100vw;
          height: 100vh;
          display: flex;
          background-color: #eee;
          color: #222;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .init-logo {
          width: 64px;
          height: 64px;
          background-image: url("/logoA.png");
          background-size: cover;
          background-position: center center;
        }
      `}</style>
      {/* <DivRound width="64" bgColor="#333" color="#ddd" style={{textAlign: "center"}}>
      open<br />
      mark</DivRound> */}
    </>
  )
}

export default Init
